export default "__VITE_ASSET__Cn2Gabk2__"